import { useEffect, useRef } from "react";

const CustomCursor = () => {
  const cursorRef = useRef(null);

  const mouse = useRef({ x: 0, y: 0 });
  const pos = useRef({ x: 0, y: 0 });
  const lastMouse = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      mouse.current.x = e.clientX;
      mouse.current.y = e.clientY;
    };

    window.addEventListener("mousemove", handleMouseMove);

    const speed = 0.08;
    const maxGap = 20;

    const animate = () => {
      // mouse movement speed
      const dx = mouse.current.x - lastMouse.current.x;
      const dy = mouse.current.y - lastMouse.current.y;
      const velocity = Math.sqrt(dx * dx + dy * dy);

      // dynamic gap (move = maxGap, stop = 0)
      const gap = Math.min(velocity * 1.5, maxGap);

      const targetX = mouse.current.x - gap;
      const targetY = mouse.current.y - gap;

      pos.current.x += (targetX - pos.current.x) * speed;
      pos.current.y += (targetY - pos.current.y) * speed;

      lastMouse.current.x = mouse.current.x;
      lastMouse.current.y = mouse.current.y;

      if (cursorRef.current) {
        cursorRef.current.style.transform = `translate3d(${pos.current.x}px, ${pos.current.y}px, 0)`;
      }

      requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <div
      ref={cursorRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "14px",
        height: "14px",
        backgroundColor: "#C72430",
        borderRadius: "50%",
        pointerEvents: "none",
        zIndex: 9999,
      }}
    />
  );
};

export default CustomCursor;
